import BlankLayout from '../../../layout/blankLayout.vue'
import List from './list.vue'
import Edit from './editor.vue'
import { OFFER_LETTER_PAGE_TYPE } from '@/constant/company'

const basePath = '/v-admin/offer-letter-management/template'
const pageType = OFFER_LETTER_PAGE_TYPE.TEMPLATE

export default {
  path: `${basePath}`,
  component: BlankLayout,
  redirect: `${basePath}/list`,
  meta: {
    isNewPage: true,
    titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterInviteRecordManagement'
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        permission: 'PERM_OFFER_TEMPLATE_MANAGEMENT',
        pageType: pageType,
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterInviteRecordManagement'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        permission: 'PERM_OFFER_TEMPLATE_MANAGEMENT',
        pageType: pageType,
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateAdd'
      }
    },
    {
      path: `${basePath}/edit/:templateId`,
      component: Edit,
      meta: {
        permission: 'PERM_OFFER_TEMPLATE_MANAGEMENT',
        pageType: pageType,
        isEdit: true,
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateEdit'
      }
    },
    {
      path: `${basePath}/view/:templateId`,
      component: Edit,
      meta: {
        permission: 'PERM_OFFER_TEMPLATE_MANAGEMENT',
        pageType: pageType,
        isView: true,
        isNewPage: true,
        titleI18nKey: 'admin.company.offerLetterInviteRecordManagement.title.offerLetterTemplateView'
      }
    }
  ]
}
